import { c as _c } from "react/compiler-runtime";
import { Card, type TableRow } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useMobileLayout from '@/hooks/use-mobile-layout';
import type { FormattedPerson } from '../../../../onboarding-business-insight.types';
import FlushTable from '../flush-table';
import MobileRow from './components/mobile-row';
import Row from './components/row';
type PeopleProps = {
  data: FormattedPerson[];
};
const People = t0 => {
  const $ = _c(16);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.people"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const isMobile = useMobileLayout();
  if (!data.length) {
    let t2;
    if ($[1] !== t) {
      t2 = t(_temp);
      $[1] = t;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== t2) {
      t3 = <Card.Empty>{t2}</Card.Empty>;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t2;
  if ($[5] !== isMobile || $[6] !== t) {
    t2 = isMobile ? [{
      text: t(_temp2)
    }] : [{
      text: t(_temp3),
      width: "60%"
    }, {
      text: t(_temp4),
      width: "40%"
    }];
    $[5] = isMobile;
    $[6] = t;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const columns = t2;
  let t3;
  if ($[8] !== t) {
    t3 = t(_temp5);
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = isMobile ? renderMobileTr : renderTr;
  let t5;
  if ($[10] !== columns || $[11] !== data || $[12] !== isMobile || $[13] !== t3 || $[14] !== t4) {
    t5 = <Card.Body className="pt-2.75 pb-3"><FlushTable aria-label={t3} columns={columns} getKeyForRow={_temp6} hideThead={isMobile} items={data} renderTr={t4} /></Card.Body>;
    $[10] = columns;
    $[11] = data;
    $[12] = isMobile;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
const renderTr = ({
  item
}: TableRow<FormattedPerson>) => <Row person={item} />;
const renderMobileTr = ({
  item
}: TableRow<FormattedPerson>) => <MobileRow person={item} />;
export default People;
function _temp($) {
  return $.table.emptyState;
}
function _temp2($_0) {
  return $_0.table.header.name;
}
function _temp3($_1) {
  return $_1.table.header.name;
}
function _temp4($_2) {
  return $_2.table.header.role;
}
function _temp5($_3) {
  return $_3.table.ariaLabel;
}
function _temp6(person) {
  return `${person.name} ${person.role}`;
}